import i18n from 'i18next';

import { GameFormat } from './gameFormat';

/** Champs d'un jeu qui peuvent varier selon la langue de la console. */
export type GameTranslation = {
    name?: string;
    description?: string;
    logo?: string;
    icon?: string;
    cover?: string;
};

/** Langue courante de la console réduite à son code court (« fr-FR » → « fr »). */
function currentLang(): string {
    return (i18n.language || '').slice(0, 2).toLowerCase();
}

export class Game {
    /* The game identifier */
    _id: string = '';

    /* The game name */
    _name: string = 'No Name';

    /* The game description */
    _description?: string;

    /* The path to the game logo */
    _logo?: string;

    /* The path to the game icon */
    _icon: string = 'https://cdn-icons-png.flaticon.com/512/2946/2946177.png';

    /* The path to the cover image */
    _cover?: string;

    /* The path to the cover image */
    _format: GameFormat = '1:1';

    /* The path to the cover image */
    _ub_version: string = '0.4';

    /* The endpoint to be used to connect to the gamepad */
    _gamepadURL?: string;

    /* The endpoint to be used to connect to the screen */
    _screenURL?: string;

    _numberOfPlayers?: string;

    _playTime?: string;

    _video?: string;

    /* Surcharges par langue (Firestore `translation.{lang}`), ex. « Categories »
       pour le Petit Bac en anglais. Lues à chaque accès : les composants qui
       affichent un jeu utilisent useTranslation et se re-rendent au changement
       de langue, les getters suivent sans toucher les appelants. */
    _translation?: Record<string, GameTranslation>;

    /** Surcharge traduite d'un champ pour la langue courante, sinon undefined. */
    private _t<K extends keyof GameTranslation>(key: K): GameTranslation[K] | undefined {
        return this._translation?.[currentLang()]?.[key];
    }

    get id(): string {
        return this._id;
    }

    get name(): string {
        return this._t('name') || this._name;
    }

    get description(): string {
        return this._t('description') || this._description || 'There is no description for this game.';
    }

    get logo(): string {
        return this._t('logo') || this._logo || this.icon;
    }

    get icon(): string {
        return this._t('icon') || this._icon;
    }

    get cover(): string {
        return this._t('cover') || this._cover || this.icon;
    }

    get format(): GameFormat {
        return this._format;
    }

    get ubVersion(): string {
        return this._ub_version;
    }

    get gamepadURL(): string | undefined {
        return this._gamepadURL;
    }

    get screenURL(): string | undefined {
        return this._screenURL;
    }

    get numberOfPlayers(): string {
        return this._numberOfPlayers || '1-4';
    }

    get playTime(): string {
        return this._playTime || '5-10 mins';
    }

    get video(): string | undefined {
        return this._video;
    }
}
